// @ts-nocheck
// set multiple fields...
export const SET_CREATE_EVENT_MULTIPLE_FIELDS =
  "SET_CREATE_EVENT_MULTIPLE_FIELDS";

export const CREATE_CONTACT_INFO_REQUEST = "CREATE_CONTACT_INFO_REQUEST";
export const CREATE_CONTACT_INFO_SUCCESS = "CREATE_CONTACT_INFO_SUCCESS";
export const CREATE_CONTACT_INFO_FAIL = "CREATE_CONTACT_INFO_FAIL";
export const UPDATE_CONTACT_INFO_REQUEST = "UPDATE_CONTACT_INFO_REQUEST";
export const UPDATE_CONTACT_INFO_SUCCESS = "UPDATE_CONTACT_INFO_SUCCESS";
export const UPDATE_CONTACT_INFO_FAIL = "UPDATE_CONTACT_INFO_FAIL";

export const CREATE_EVENT_INFO_REQUEST = "CREATE_EVENT_INFO_REQUEST";
export const CREATE_EVENT_INFO_SUCCESS = "CREATE_EVENT_INFO_SUCCESS";
export const CREATE_EVENT_INFO_FAIL = "CREATE_EVENT_INFO_FAIL";

export const ADD_EVENT_ID_REQUEST = "ADD_EVENT_ID_REQUEST";
export const ADD_EVENT_ID_SUCCESS = "ADD_EVENT_ID_SUCCESS";
export const ADD_EVENT_ID_FAIL = "ADD_EVENT_ID_FAIL";

export const UPDATE_EVENT_INFO_REQUEST = "UPDATE_EVENT_INFO_REQUEST";
export const UPDATE_EVENT_INFO_SUCCESS = "UPDATE_EVENT_INFO_SUCCESS";
export const UPDATE_EVENT_INFO_FAIL = "UPDATE_EVENT_INFO_FAIL";

export const UPDATE_SUBMITTED_KEY_REQUEST = "UPDATE_SUBMITTED_KEY_REQUEST";
export const UPDATE_SUBMITTED_KEY_SUCCESS = "UPDATE_SUBMITTED_KEY_SUCCESS";
export const UPDATE_SUBMITTED_KEY_FAIL = "UPDATE_SUBMITTED_KEY_FAIL";

export const CREATE_SESSION_STEP1_REQUEST = "CREATE_SESSION_STEP1_REQUEST";
export const CREATE_SESSION_STEP1_SUCCESS = "CREATE_SESSION_STEP1_SUCCESS";
export const CREATE_SESSION_STEP1_FAIL = "CREATE_SESSION_STEP1_FAIL";
export const CLEAR_SESSION_STEP1_FORM = "CLEAR_SESSION_STEP1_FORM";

export const SET_CONTACT_INFO_FORM = "SET_CONTACT_INFO_FORM";
export const SET_EVENT_INFO_FORM = "SET_EVENT_INFO_FORM";
export const SET_SESSION_STEP_1_FORM = "SET_SESSION_STEP_1_FORM";
export const SET_SESSION_STEP_2_FORM = "SET_SESSION_STEP_2_FORM";

export const SET_SESSION_STEP_2_DYNAMIC_POSITIONS =
  "SET_SESSION_STEP_2_DYNAMIC_POSITIONS";
export const CLEAR_SESSION_STEP_2_FORM = "CLEAR_SESSION_STEP_2_FORM";

export const ADD_SESSION_ID_TO_EVENT_REQUEST =
  "ADD_SESSION_ID_TO_EVENT_REQUEST";
export const ADD_SESSION_ID_TO_EVENT_SUCCESS =
  "ADD_SESSION_ID_TO_EVENT_SUCCESS";
export const ADD_SESSION_ID_TO_EVENT_FAIL = "ADD_SESSION_ID_TO_EVENT_FAIL";

export const UPDATE_SESSION_STEP1_REQUEST = "UPDATE_SESSION_STEP1_REQUEST";
export const UPDATE_SESSION_STEP1_SUCCESS = "UPDATE_SESSION_STEP1_SUCCESS";
export const UPDATE_SESSION_STEP1_FAIL = "UPDATE_SESSION_STEP1_FAIL";

export const SKIP_SESSION_STEP1_REQUEST = "SKIP_SESSION_STEP1_REQUEST";
export const SKIP_SESSION_STEP1_SUCCESS = "SKIP_SESSION_STEP1_SUCCESS";
export const SKIP_SESSION_STEP1_FAIL = "SKIP_SESSION_STEP1_FAIL";

export const UPDATE_SESSION_STEP1_DATA = "UPDATE_SESSION_STEP1_DATA";

export const CLEAR_SESSION_STEP1_DATA = "CLEAR_SESSION_STEP1_DATA";

export const GET_ALL_POSITIONS_REQUEST = "GET_ALL_POSITIONS_REQUEST";
export const GET_ALL_POSITIONS_SUCCESS = "GET_ALL_POSITIONS_SUCCESS";
export const GET_ALL_POSITIONS_FAIL = "GET_ALL_POSITIONS_FAIL";

export const GET_POSITIONS_BY_NAME_REQUEST = "GET_POSITIONS_BY_NAME_REQUEST";
export const GET_POSITIONS_BY_NAME_SUCCESS = "GET_POSITIONS_BY_NAME_SUCCESS";
export const GET_POSITIONS_BY_NAME_FAIL = "GET_POSITIONS_BY_NAME_FAIL";

export const CREATE_SESSION_POSITION_REQUEST =
  "CREATE_SESSION_POSITION_REQUEST";
export const CREATE_SESSION_POSITION_SUCCESS =
  "CREATE_SESSION_POSITION_SUCCESS";
export const CREATE_SESSION_POSITION_FAIL = "CREATE_SESSION_POSITION_FAIL";

export const ADD_SESSION_POSITION_REQUEST = "ADD_SESSION_POSITION_REQUEST";
export const ADD_SESSION_POSITION_SUCCESS = "ADD_SESSION_POSITION_SUCCESS";
export const ADD_SESSION_POSITION_FAIL = "ADD_SESSION_POSITION_FAIL";

export const ADD_REQUEST_QUOTE_REQUEST = "ADD_REQUEST_QUOTE_REQUEST";
export const ADD_REQUEST_QUOTE_SUCCESS = "ADD_REQUEST_QUOTE_SUCCESS";
export const ADD_REQUEST_QUOTE_FAIL = "ADD_REQUEST_QUOTE_FAIL";

export const GET_ALL_SESSIONS_POSITIONS_REQUEST =
  "GET_ALL_SESSIONS_POSITIONS_REQUEST";
export const GET_ALL_SESSIONS_POSITIONS_SUCCESS =
  "GET_ALL_SESSIONS_POSITIONS_SUCCESS";
export const GET_ALL_SESSIONS_POSITIONS_FAIL =
  "GET_ALL_SESSIONS_POSITIONS_FAIL";

export const UPDATE_SESSION_POSITION_REQUEST =
  "UPDATE_SESSION_POSITION_REQUEST";
export const UPDATE_SESSION_POSITION_SUCCESS =
  "UPDATE_SESSION_POSITION_SUCCESS";
export const UPDATE_SESSION_POSITION_FAIL = "UPDATE_SESSION_POSITION_FAIL";

export const SET_SESSION_DATA = "SET_SESSION_DATA";

export const CLEAR_SESSION_DATA = "CLEAR_SESSION_DATA";
export const CLEAR_SESSION_POSITIONS_FOR_GIVEN_SESSION =
  "CLEAR_SESSION_POSITIONS_FOR_GIVEN_SESSION";
export const CLEAR_ALL_SESSION_POSITIONS = "CLEAR_ALL_SESSION_POSITIONS";

export const DELETE_SESSION_POSITION_REQUEST =
  "DELETE_SESSION_POSITION_REQUEST";
export const DELETE_SESSION_POSITION_SUCCESS =
  "DELETE_SESSION_POSITION_SUCCESS";
export const DELETE_SESSION_POSITION_FAIL = "DELETE_SESSION_POSITION_FAIL";

export const DELETE_SESSION_POSITIONS_OF_GIVEN_SESSION =
  "DELETE_SESSION_POSITIONS_OF_GIVEN_SESSION";

export const GET_SESSIONS_FOR_SPECIFIC_EVENT_REQUEST =
  "GET_SESSIONS_FOR_SPECIFIC_EVENT_REQUEST";
export const GET_SESSIONS_FOR_SPECIFIC_EVENT_SUCCESS =
  "GET_SESSIONS_FOR_SPECIFIC_EVENT_SUCCESS";
export const GET_SESSIONS_FOR_SPECIFIC_EVENT_FAIL =
  "GET_SESSIONS_FOR_SPECIFIC_EVENT_FAIL";

export const DELETE_SESSION_REQUEST = "DELETE_SESSION_REQUEST";
export const DELETE_SESSION_SUCCESS = "DELETE_SESSION_SUCCESS";
export const DELETE_SESSION_FAIL = "DELETE_SESSION_FAIL";

export const UPDATE_CURRENT_SESSION_STEP1 = "UPDATE_CURRENT_SESSION_STEP1";
export const SET_CURRENT_EDITABLE_POSITION = "SET_CURRENT_EDITABLE_POSITION";

// edit multiple positions...
export const EDIT_MULTIPLE_POSITIONS_LOADING =
  "EDIT_MULTIPLE_POSITIONS_LOADING";
export const EDIT_MULTIPLE_POSITIONS_SUCCESS =
  "EDIT_MULTIPLE_POSITIONS_SUCCESS";
export const EDIT_MULTIPLE_POSITIONS_FAIL = "EDIT_MULTIPLE_POSITIONS_FAIL";
// edit multiple positions...

export const RESET_EventInfoSubmittedForCurrentIteration =
  "RESET_EventInfoSubmittedForCurrentIteration";
export const RESET_CREATE_EVENT_SLICE = "RESET_CREATE_EVENT_SLICE";
export const CLEAR_RESET_COUNT = "CLEAR_RESET_COUNT";

export const SET_LAST_STEP_LOADING = "SET_LAST_STEP_LOADING";

// position board
export const ADD_SESSION_TO_POSITION_BOARD = "ADD_SESSION_TO_POSITION_BOARD";
export const REMOVE_SESSION_FROM_POSITION_BOARD =
  "REMOVE_SESSION_FROM_POSITION_BOARD";
export const EMPTY_POSITION_BOARD = "EMPTY_POSITION_BOARD";

// toggle edit button on timeline
export const TOGGLE_POSITION_BUTTON_TIMELINE =
  "TOGGLE_POSITION_BUTTON_TIMELINE";

// set form as partial event
export const SET_FORM_AS_PARTIAL_EVENT = "SET_FORM_AS_PARTIAL_EVENT";